import pageSettingsDesktop from './panels/settings/desktop/pageSettingsDesktop';
import pageSettingsMobile from './panels/settings/mobile/pageSettingsMobile';
import {
  signUpSettingsDesktop,
  signInSettingsDesktop,
} from './panels/settings/desktop/signupSettingsDesktop';
import { MemberAuthSuccessModal } from './panels/settings/desktop/memberAuthSuccessModal';
import { MemberAuthCustomFormWarningModal } from './panels/settings/desktop/memberAuthCustomFormWarningModal';
import { MemberAuthInstallErrorModal } from './panels/settings/desktop/memberAuthInstallErrorModal';
import { registerMemberAuthMigrationHooks } from './panels/settings/desktop/memberAuthMigrationActions';
import * as groupsApi from './utils/groupsApi';
import { createJoinCommunityStatusApi } from './utils/joinCommunityStatusApi';
import type { EditorAPI } from '#packages/editorAPI';

const settingsPanels = {
  main: pageSettingsDesktop,
  mobile: pageSettingsMobile,
  signup: signUpSettingsDesktop,
  signIn: signInSettingsDesktop,
};

const modals = {
  memberAuthSuccessModal: MemberAuthSuccessModal,
  memberAuthCustomFormWarningModal: MemberAuthCustomFormWarningModal,
  memberAuthInstallErrorModal: MemberAuthInstallErrorModal,
};

const utils = {
  groupsApi,
  createJoinCommunityStatusApi,
};

const onPreviewReady = (editorAPI: EditorAPI): void => {
  registerMemberAuthMigrationHooks(editorAPI);
};

export { settingsPanels, modals, utils, onPreviewReady };
